module.exports = __webpack_public_path__ + "d2205070aa25b79445a984099a758e27.MP3";